import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CommonState = {
  toast: {
    type: 'error';
    message: '';
  };
};

const initialState: CommonState = {
  toast: {
    type: 'error',
    message: '',
  },
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<{ type: 'error'; message: '' }>) => {
      state.toast = action.payload;
    },
    removeToastMessage: (state) => {
      state.toast.message = '';
    },
  },
});

export const commonActions = commonSlice.actions;
export const commonReducer = commonSlice.reducer;
